export const getNestedValue = (obj, path, fallback = '') => {
    return path.split('.').reduce((acc, key) => acc?.[key], obj) ?? fallback;
};
